(function () {
  'use strict';

  // ─── STORAGE ───────────────────────────────────────────────
  var STORAGE_KEY = 'sw_wl_v2';

  function getItems() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) { return []; }
  }

  function saveItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateBadges();
  }

  function hasHandle(handle) {
    return getItems().some(function (x) { return x.handle === handle; });
  }

  function addItem(id, handle) {
    var items = getItems();
    if (!hasHandle(handle)) {
      items.push({ id: String(id), handle: String(handle) });
      saveItems(items);
    }
  }

  function removeItem(handle) {
    saveItems(getItems().filter(function (x) { return x.handle !== handle; }));
  }

  function toggleItem(id, handle) {
    hasHandle(handle) ? removeItem(handle) : addItem(id, handle);
    return hasHandle(handle);
  }

  function clearAll() { saveItems([]); }

  function getCount() { return getItems().length; }

  // ─── BADGE ─────────────────────────────────────────────────
  function updateBadges() {
    var count = getCount();
    document.querySelectorAll('.wl-badge').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  // ─── TOAST ─────────────────────────────────────────────────
  function toast(msg) {
    var el = document.getElementById('wl-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'wl-toast';
      el.style.cssText = [
        'position:fixed', 'bottom:24px', 'left:50%',
        'transform:translateX(-50%) translateY(80px)',
        'background:#1b3a1b', 'color:#fff',
        'padding:10px 22px', 'border-radius:8px',
        'font-size:13px', 'z-index:999999',
        'transition:all .3s', 'opacity:0',
        'pointer-events:none', 'white-space:nowrap'
      ].join(';');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.style.opacity = '1';
    el.style.transform = 'translateX(-50%) translateY(0)';
    clearTimeout(el._t);
    el._t = setTimeout(function () {
      el.style.opacity = '0';
      el.style.transform = 'translateX(-50%) translateY(80px)';
    }, 2500);
  }

  // ─── PRODUCT CARD BUTTON ───────────────────────────────────
  window.wlToggle = function (e, btn) {
    e.preventDefault();
    e.stopPropagation();
    var id = String(btn.getAttribute('data-pid'));
    var handle = String(btn.getAttribute('data-phandle'));
    var wished = toggleItem(id, handle);
    setCardBtnState(btn, wished);
    toast(wished ? '❤️ Added to wishlist!' : 'Removed from wishlist');
  };

  function setCardBtnState(btn, wished) {
    btn.classList.toggle('wl-active', wished);
    var svg = btn.querySelector('svg');
    if (svg) {
      svg.setAttribute('fill', wished ? '#e74c3c' : 'none');
      svg.setAttribute('stroke', wished ? '#e74c3c' : 'currentColor');
    }
  }

  // ─── INIT ──────────────────────────────────────────────────
  function init() {
    updateBadges();

    document.querySelectorAll('.wl-btn').forEach(function (btn) {
      var handle = String(btn.getAttribute('data-phandle'));
      setCardBtnState(btn, hasHandle(handle));
    });

    var pg = document.getElementById('wl-page');
    if (pg) { renderPage(pg); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ─── WISHLIST PAGE ─────────────────────────────────────────
  async function renderPage(container) {
    var items = getItems();

    if (items.length === 0) {
      container.innerHTML = emptyHTML();
      return;
    }

    container.innerHTML = '<p style="text-align:center;padding:40px;color:#888;">Loading your wishlist...</p>';

    try {
      var results = await Promise.all(
        items.map(function (item) {
          return fetch('/products/' + item.handle + '.json')
            .then(function (r) { return r.json(); })
            .then(function (d) {
              var p = d.product;
              if (p) { p.__wl_handle = item.handle; }
              return p || null;
            })
            .catch(function () { return null; });
        })
      );

      var products = results.filter(Boolean);

      if (!products.length) {
        container.innerHTML = '<p style="text-align:center;padding:40px;color:#888;">Could not load products. Please refresh the page.</p>';
        return;
      }

      var total = products.reduce(function (s, p) {
        return s + (parseInt(p.variants[0].price) || 0);
      }, 0);

      container.innerHTML = pageCSS() + pageHTML(products, total);

    } catch (err) {
      console.error('Wishlist Error:', err);
      container.innerHTML = '<p style="color:red;padding:20px;">Something went wrong. Please refresh the page.</p>';
    }
  }

  function emptyHTML() {
    return '<div style="text-align:center;padding:64px 20px;">' +
      '<div style="font-size:52px;margin-bottom:16px;">🤍</div>' +
      '<h3 style="font-size:20px;margin-bottom:10px;color:#1b3a1b;">Your wishlist is empty</h3>' +
      '<p style="color:#888;margin-bottom:24px;">Browse our products and click the heart icon to save your favourites.</p>' +
      '<a href="/collections/all" style="display:inline-block;background:#1b3a1b;color:#fff;padding:12px 30px;border-radius:8px;text-decoration:none;font-size:14px;">Shop Now</a>' +
      '</div>';
  }

  function pageCSS() {
    return '<style>' +
      '.wlp-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(210px,1fr));gap:18px;margin-bottom:20px;}' +
      '.wlp-card{background:#fff;border:1px solid #e5e5e5;border-radius:12px;overflow:hidden;transition:opacity .3s,transform .3s;}' +
      '.wlp-card:hover{box-shadow:0 6px 20px rgba(0,0,0,0.08);}' +
      '.wlp-card img{width:100%;height:185px;object-fit:contain;background:#f8f8f8;padding:12px;display:block;}' +
      '.wlp-body{padding:14px;}' +
      '.wlp-vendor{font-size:11px;color:#999;text-transform:uppercase;letter-spacing:.5px;margin-bottom:3px;}' +
      '.wlp-title{font-size:14px;font-weight:600;color:#1a1a1a;margin-bottom:8px;line-height:1.4; min-height: 41px;}' +
      '.wlp-price{font-size:16px;font-weight:700;color:#1b3a1b;margin-bottom:12px;}' +
      '.wlp-actions{display:inline-block; width:100%;}' +
      '.wlp-atc{flex:1;background:#1b3a1b;color:#fff;border:none;border-radius:7px;padding:9px 8px;font-size:12px;cursor:pointer;}' +
      '.wlp-atc:hover{background:#2a5a2a;}' +
      '.wlp-rem{background:#004226;border:1px solid #004226;border-radius:7px;padding:9px 12px;font-size:14px;cursor:pointer;color:#aaa;line-height:1; width: 100%;}' +
      '.wlp-rem:hover{border-color:#ffaaaa;color:#cc3333;background:#fff5f5;}' +
      '.wlp-bar{display:flex;align-items:center;justify-content:space-between;margin-bottom:18px;}' +
      '.wlp-clearall{background:none;border:1px solid #ffbbbb;border-radius:6px;padding:6px 14px;color:#cc3333;font-size:12px;cursor:pointer;}' +
      '.wlp-clearall:hover{background:#fff5f5;}' +
      '.wlp-summary{background:#f2f7f2;border:1px solid #c5dcc5;border-radius:10px;padding:18px 22px;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:14px;}' +
      '.wlp-allatc{background:#1b3a1b;color:#fff;border:none;border-radius:8px;padding:11px 26px;font-size:13px;cursor:pointer;}' +
      '.wlp-allatc:hover{background:#2a5a2a;}' +
      '@media(max-width:480px){.wlp-grid{grid-template-columns:1fr 1fr;}.wlp-actions{flex-direction:column;}}' +
      '</style>';
  }

  function pageHTML(products, total) {
    var count = products.length;

    var bar = '<div class="wlp-bar">' +
      '<span style="font-size:14px;color:#888;">' + count + ' item' + (count !== 1 ? 's' : '') + ' saved</span>' +
      '<button class="wlp-clearall" onclick="wlClearAll()">✕ Remove All</button>' +
      '</div>';

    var grid = '<div class="wlp-grid">';
    products.forEach(function (p) {
      var wlHandle = p.__wl_handle;
      var price = parseInt(p.variants[0].price) || 0;
      var comparePrice = parseInt(p.variants[0].compare_at_price) || 0;
      var img = p.images && p.images[0] ? p.images[0].src : '';
      var vid = String(p.variants[0].id);
      var titleSafe = p.title.replace(/\\/g, '\\\\').replace(/'/g, "\\'");

      grid += '<div class="wlp-card" id="wlp-' + wlHandle + '">' +
        '<a href="/products/' + p.handle + '">' +
        '<img src="' + img + '" alt="' + p.title + '" loading="lazy">' +
        '</a>' +
        '<div class="wlp-body">' +
        '<div class="wlp-vendor">' + (p.vendor || '') + '</div>' +
        '<div class="wlp-title">' + p.title + '</div>' +
        '<div class="wlp-price">&#8358;' + price.toLocaleString() +
        (comparePrice > price
          ? ' <span style="text-decoration:line-through;color:#bbb;font-size:12px;margin-left:4px;">&#8358;' + comparePrice.toLocaleString() + '</span>'
          : '') +
        '</div>' +
        '<div class="wlp-actions">' +
        //'<button class="wlp-atc" onclick="wlAddToCart(\'' + vid + '\',\'' + titleSafe + '\')">Add to Cart</button>' +
        '<button class="wlp-rem" onclick="wlRemove(\'' + wlHandle + '\')">✕</button>' +
        '</div>' +
        '</div>' +
        '</div>';
    });
    grid += '</div>';

    var summary = '<div class="wlp-summary">' +
      '<div>' +
      '<div style="font-size:12px;color:#888;margin-bottom:3px;">' + count + ' item' + (count !== 1 ? 's' : '') + ' in your wishlist</div>' +
      '<div style="font-size:20px;font-weight:700;color:#1b3a1b;">Total: &#8358;' + total.toLocaleString() + '</div>' +
      '</div>' +
      //'<button class="wlp-allatc" onclick="wlAddAllToCart()">Add All to Cart</button>' +
      '</div>';

    return bar + grid + summary;
  }

  // ─── PAGE ACTIONS ──────────────────────────────────────────
  window.wlRemove = function (handle) {
    var card = document.getElementById('wlp-' + handle);
    if (card) {
      card.style.opacity = '0';
      card.style.transform = 'scale(0.9)';
    }
    setTimeout(function () {
      removeItem(handle);
      var pg = document.getElementById('wl-page');
      if (pg) { renderPage(pg); }
      toast('Removed from wishlist');
    }, 300);
  };

  window.wlClearAll = function () {
    if (!confirm('Are you sure you want to clear your wishlist?')) { return; }
    clearAll();
    var pg = document.getElementById('wl-page');
    if (pg) { renderPage(pg); }
    toast('Wishlist cleared');
  };

  window.wlAddToCart = async function (variantId, title) {
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      });
      if (res.ok) {
        toast('🛒 Added to cart: ' + title);
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } else {
        toast('Could not add to cart. Please visit the product page.');
      }
    } catch (e) {
      toast('Something went wrong. Please try again.');
    }
  };

  window.wlAddAllToCart = async function () {
    var items = getItems();
    if (!items.length) { return; }
    toast('Adding all items to cart...');
    try {
      var cartItems = [];
      for (var i = 0; i < items.length; i++) {
        var r = await fetch('/products/' + items[i].handle + '.json');
        var d = await r.json();
        if (d.product) {
          cartItems.push({ id: parseInt(d.product.variants[0].id), quantity: 1 });
        }
      }
      if (cartItems.length) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: cartItems })
        });
        toast('🛒 ' + cartItems.length + ' item' + (cartItems.length !== 1 ? 's' : '') + ' added to cart!');
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
    } catch (e) {
      toast('Something went wrong. Please try again.');
    }
  };

})();
